import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@tillersystems/stardust';
import { connect } from 'react-redux';
import { translate, Trans } from 'react-i18next';
import { bindActionCreators } from 'redux';
import ReactGA from 'react-ga';
import { BounceLoader } from 'react-spinners';
import Media from 'react-media';

import { Page, Image, Theme } from '../../components';

import * as NavActions from '../../services/NavigationService/actions';
import * as Actions from '../../services/TillerBackService/actions';
import * as SFActions from '../../services/DataServices/SFDataService/actions';

const { object, func } = PropTypes;

/**
 * Thanks page
 *
 * This component is in charge of displaying
 * a the thanks page
 *
 * @return {jsx}
 */

export class Thanks extends Component {
  state = {
    loading: false,
    stageValue: 'One more step',
    stageNumber: 6,
  };
  /**
   * PropTypes validation
   */
  static propTypes = {
    actions: object.isRequired,
    opportunity: object.isRequired,
    tillerBack: object,
    t: func.isRequired,
  };

  /**
   * Default Props
   */
  static defaultProps = {
    tillerBack: null,
  };

  componentDidMount() {
    const { opportunity, actions } = this.props;
    const { stageValue, stageNumber } = this.state;

    if (opportunity._stageValue !== null) {
      actions.opportunityNeedUpdate(opportunity.getId(), stageValue, stageNumber);
    }
    actions.setCurrentStep(5);
  }

  componentWillReceiveProps(nextProps) {
    const { actions, opportunity, tillerBack } = this.props;
    if (nextProps.tillerBack !== tillerBack) {
      const stageValue = 'Done';
      const stageNumber = 7;

      actions.opportunityNeedUpdate(opportunity.getId(), stageValue, stageNumber);

      if (nextProps.tillerBack.data.success) {
        this.setState({
          loading: false,
        });
      } else {
        this.setState({
          loading: false,
        });
      }
    }
  }

  handleClick = () => {
    const { actions } = this.props;
    actions.askForBackOfficeCreation();
    this.setState({
      loading: true,
    });
    // Send Google Analytics event
    ReactGA.event({
      category: 'User',
      action: 'Has completed onboarding',
      label: 'Button',
    });
  };

  render() {
    const {
      t,
      tillerBack,
      opportunity: { _contactEmail },
    } = this.props;
    const { loading } = this.state;
    if (loading) {
      return (
        <div className="Loader-container">
          <BounceLoader color="#1F95CE" loading={loading} />
        </div>
      );
    }
    if (tillerBack === null) {
      return (
        <Page>
          <Page.Title>{t('thanksPage.heading')}</Page.Title>
          <Page.Paragraph>{t('thanksPage.content')}</Page.Paragraph>
          <Button big primary fluid onClick={this.handleClick} disable={loading}>
            {t('thanksPage.button')}
          </Button>
        </Page>
      );
    }
    if (tillerBack.data.success === true) {
      return (
        <Page textCenter>
          <Media query={{ maxWidth: Theme.breakpoints.md }}>
            {matches =>
              matches ? (
                <Image src="/img/illu_last.svg" alt="" size="140px" />
              ) : (
                <Image src="/img/illu_last.svg" alt="" size="180px" />
              )
            }
          </Media>
          <Page.Title>{t('thanksPage.success_heading')}</Page.Title>
          <Page.Paragraph>
            <Trans i18nKey="thanksPage.success_content">
              Vous allez recevoir dans les prochaines 48h un email sur votre adresse
              {{ _contactEmail }}. Il contient un lien pour créer votre mot de passe vous permettant
              d'accéder à votre back-office, votre "cabine de pilotage" durant votre aventure chez
              Tiller.
            </Trans>
          </Page.Paragraph>
          <Page.Paragraph>{t('thanksPage.success_catchPhrase')}</Page.Paragraph>
          <Page.Paragraph>{t('thanksPage.thx')}</Page.Paragraph>
        </Page>
      );
    }
    return null;
  }
}

const mapStateToProps = state => ({
  tillerBack: state.tillerBack,
  opportunity: state.opportunity,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ ...NavActions, ...Actions, ...SFActions }, dispatch),
});

const ThanksConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
)(Thanks);

export default translate('translations')(ThanksConnect);



// WEBPACK FOOTER //
// ./src/pages/Thanks/index.js